import { motion, useTransform, useScroll } from "framer-motion";
import React, { useRef } from "react";
import {HiArrowRight} from "react-icons/hi2";
import {BsArrow90DegRight} from "react-icons/bs";

const HorizontalScrollCarousel = () => {
    const targetRef = useRef(null);
    const { scrollYProgress } = useScroll({
        target: targetRef,
    });

    const x = useTransform(scrollYProgress, [0, 1], ["7%", "-86%"]);

    return (
        <section ref={targetRef} className="relative h-[300vh] ">
            <div className="sticky top-0 flex h-screen items-center overflow-hidden">
                <motion.div style={{ x }} className="flex gap-4">
                    {cards.map((card) => {
                        return <Card card={card} key={card.id} />;
                    })}
                </motion.div>
            </div>
        </section>
    );
};

const Card = ({ card }) => {
    return (
        <div
            key={card.id}
            className="group relative h-screen overflow-hidden flex items-center"
        >
            <div className="flex">
                <div className="px-4 w-[40rem] py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
                    <div className="group" href="#">
                        <motion.div
                            className="relative pt-[50%] sm:pt-[70%] rounded-xl overflow-hidden"
                            variants={{
                                hidden: { opacity: 0, x: -50 },
                                visible: { opacity: 1, x: 0 }
                            }}
                            initial="hidden"
                            whileInView="visible"
                            transition={{duration: 0.6, delay: 0.4}}
                            viewport={{once: false}}
                        >
                            <img className="size-full absolute top-0 start-0 object-cover group-hover:scale-105 transition-transform duration-500 ease-in-out rounded-xl opacity-50" src="https://dummyimage.com/800x600" alt="Description"/>
                            <span className="absolute top-0 end-0 rounded-se-xl rounded-es-xl text-xs font-medium bg-pink-500 text-white py-1.5 px-3">
                                Step No.{ card.id }
                            </span>
                        </motion.div>
                        <div className="mt-7">
                            <h3 className="text-2xl font-bold text-pink-500">
                                { card.step }
                            </h3>
                            <p className="mt-3 text-gray-800 w-full">
                                { card.content }
                            </p>
                        </div>
                    </div>
                </div>
                { card.id!==7 ?
                    <motion.div
                        className="text-6xl my-auto mx-16"
                        variants={{
                            hidden: { opacity: 0, x: -50 },
                            visible: { opacity: 1, x: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <HiArrowRight />
                    </motion.div> :
                    <motion.div
                        className="my-auto text-6xl mx-16"
                        variants={{
                            hidden: { opacity: 0, y: -50 },
                            visible: { opacity: 1, y: 0 }
                        }}
                        initial="hidden"
                        whileInView="visible"
                        transition={{duration: 0.6, delay: 0.8}}
                        viewport={{once: false}}
                    >
                        <BsArrow90DegRight className="rotate-90" />
                    </motion.div> }
            </div>
        </div>
    );
};

const cards = [
    {
        step: "Title of step No.1",
        content: "A brief description of protocol step No.1",
        id: 1
    },
    {
        step: "Title of step No.2",
        content: "A brief description of protocol step No.2",
        id: 2
    },
    {
        step: "Title of step No.3",
        content: "A brief description of protocol step No.3",
        id: 3
    },
    {
        step: "Title of step No.4",
        content: "A brief description of protocol step No.4",
        id: 4
    },
    {
        step: "Title of step No.5",
        content: "A brief description of protocol step No.5",
        id: 5,
    },
    {
        step: "Title of step No.6",
        content: "A brief description of protocol step No.6",
        id: 6,
    },
    {
        step: "Title of step No.7",
        content: "A brief description of protocol step No.7",
        id: 7,
    }
];

export default function HorizontalScrollProtocol(){
    return(
        <HorizontalScrollCarousel />
    )
}